import React, { useMemo, useEffect, useState } from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { agencyHasFeature, token } from "../../modules/auth";
import {
  fetchAgencies,
  fetchCompanies,
  uploadHotelGroupLogo,
} from "../../redux/actions";
import { ValueContainerDisplayResult } from "../corporate/reports/MultiValueComponents";
import MultiSelect from "../../ui/MultiSelect";
import { ButtonBrand, ButtonPrimary } from "../Button";
import { fetchHotelGroupsForProgrammes } from "../../services/hotelGroupService/preferredProgrammesService";
import { addGroupToPreferredProgramme } from "../../redux/actions/preferred-programs";
import {
  agencyObject,
  isAgencyAdmin,
  isCompanyAdmin,
  isCompanyUser,
  isRolePlatformAdmin,
} from "../../modules/permissions";
import { AGENCY_PERMISSIONS } from "../../constants";


let HotelGroupAddGroupToProgram = ({
  token,
  fetchAgencies,
  fetchCompanies,
  addGroupToPreferredProgramme,
  handleSubmit,
  isAgencyAdmin,
  isCompanyAdmin,
  isCompanyUser,
  isRolePlatformAdmin,
  company,
  agency,
  onAddGroup = (programmeId, hotelGroupId) => {},
                                     agencyHasCorporatePermission,
                                     agencyCanHaveChildAgencies
}) => {
  const [groups, setGroups] = useState([]);
  const [agencies, setAgencies] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState([]);
  const [selectedAgency, setSelectedAgency] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [error, setError] = useState(null)

  useEffect(() => {
    fetchHotelGroupsForProgrammes(token).then(response => {
      setGroups(response.data);
    });
    if (isAgencyAdmin || isRolePlatformAdmin) {
      fetchAgencies(token, 1, { visibleOnly: true }, true).then(response => {
        setAgencies(response.data.data);
      });
      fetchCompanies(
        token,
        1,
        { visibleOnly: true, corporate: true },
        true
      ).then(response => {
        setCompanies(response.data.data);
      });
    }
  }, []);

  const getHotelGroupOptions = () => {
    let options = [];
    if (groups && groups.length > 0) {
      groups
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(group => {
          options.push({
            text: group.name,
            value: group.id,
            label: group.name,
            parent: group.parentGroup,
            childVenues: group.childVenues,
          });
        });
    }
    return options;
  };

  const getAgencyOptions = () => {
    let options = [];
    if (agencies && agencies.length > 0) {
      agencies
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(agency => {
          options.push({
            text: agency.name,
            value: agency.id,
            label: agency.name,
          });
        });
    }
    return options;
  };

  const getCompanyOptions = () => {
    let options = [];
    if (companies && companies.length > 0) {
      companies
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(company => {
          options.push({
            text: company.name,
            value: company.id,
            label: company.name,
          });
        });
    }
    return options;
  };
  const handleHotelGroupSelect = e => {
    setSelectedGroup(e);
  };

  const handleAgencySelect = e => {
    setSelectedAgency(e);

    const params = { visibleOnly: true,corporate: true };
    if ( e?.value ) {
      params.agency = e.value;
    }

    fetchCompanies(
      token,
      1,
      params,
      true
    ).then(response => {
      setCompanies(response.data.data);
    });
  };

  const handleCompanySelect = e => {
    setSelectedCompany(e);
  };

  const onSubmit = values => {
    addGroupToPreferredProgramme(
      token,
      selectedGroup.value,
      agencyCanHaveChildAgencies || isRolePlatformAdmin? selectedAgency?.value : agency.id,
      !(isCompanyAdmin && company) || isRolePlatformAdmin ?selectedCompany.value :  company.id
  ).then(response => {
      if(response.data?.error) {
        setError(response.data.error);
      }else{
        onAddGroup(response.data?.preferred_programme, response.data?.hotel_group);
      }
    });

  };
  const agencyOptions = getAgencyOptions();
  const companyOptions = getCompanyOptions();
  return (
    <div>
      <p>
        Select a Hotel Group/Brand to add to{" "}{isCompanyAdmin || isCompanyUser ? "your" : "a"} Preferred Programme
      </p>
      <form className="container py-5" onSubmit={handleSubmit(onSubmit)}>
        <div className={"flex justify-between"}>
          <div>
            <MultiSelect
              isClearable={true}
              name="hotel_group"
              label="Choose a Hotel Group/Brand"
              options={getHotelGroupOptions()}
              closeMenuOnSelect={true}
              hideSelectedOptions={false}
              wrapperClassName="mb-0"
              onChange={e => handleHotelGroupSelect(e)}
              value={selectedGroup}
              autoComplete={"off"}
              style={{
                searchBox: {
                  "border-radius": "0px",
                },
              }}
            />
          </div>

          {selectedGroup?.value && ((isAgencyAdmin && agencyCanHaveChildAgencies) || isRolePlatformAdmin)   ? (
            <div className={"mr-5"} style={{ width: "250px" }}>
              <MultiSelect
                isClearable={true}
                name="agency"
                label="Add to an Agency P.P."
                options={agencyOptions}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                wrapperClassName="mb-0"
                onChange={e => {handleAgencySelect(e)}}
                value={selectedAgency}
                autoComplete={"off"}
                style={{
                  searchBox: {
                    "border-radius": "0px",
                  },
                }}
              />
            </div>
          ) : null}
          {selectedGroup?.value &&
          companyOptions?.length > 0 &&
          ((isAgencyAdmin && agencyHasCorporatePermission) || isRolePlatformAdmin) ? (
            <div className={"mr-5"} style={{ width: "250px" }}>
              <MultiSelect
                isClearable={true}
                name="agency"
                label="Add to a Company P.P."
                options={companyOptions}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                wrapperClassName="mb-0"
                onChange={e => handleCompanySelect(e)}
                value={selectedCompany}
                autoComplete={"off"}
                style={{
                  searchBox: {
                    "border-radius": "0px",
                  },
                }}
                help
              />
              {agencyOptions?.length > 1 ? (<p>
                <em>
                  <small>
                    Selecting an agency will limit these options to corporates
                    managed by that agency
                  </small>
                </em>
              </p>) : null}
            </div>
          ) : null}
          <div className={"py-2"}>
            <ButtonBrand type="submit">Add to Programme</ButtonBrand>
          </div>
        </div>
        {error && (
          <div className="text-red mt-2">
           {error}
          </div>
        )}
      </form>
      {!(isCompanyAdmin || isCompanyUser) && (selectedGroup?.text && (selectedAgency?.text || selectedCompany?.text)) ?
        <p>This will add <strong>{selectedGroup.text}</strong> to <strong>{`${selectedCompany?.text ? selectedCompany.text : selectedAgency.text }'s`}</strong> Preferred Programme</p>
        : null}
      {(isAgencyAdmin && !agencyCanHaveChildAgencies) && (selectedGroup?.text) && (!selectedCompany?.text && !selectedAgency?.text ) ?
        <p>This will add <strong>{selectedGroup.text}</strong> to <strong>{agency.name}'s</strong> Preferred Programme</p>
        : null}
      {/*<MultiSelect*/}
      {/*  name="hotel_group"*/}
      {/*  label="Filter by Hotel Group"*/}
      {/*  options={getHotelGroupOptions()}*/}
      {/*  closeMenuOnSelect={true}*/}
      {/*  hideSelectedOptions={false}*/}
      {/*  wrapperClassName="mb-0"*/}
      {/*  onChange={e => handleHotelGroupSelect(e)}*/}
      {/*  value={selectedHotelGroups}*/}
      {/*  autoComplete={'off'}*/}
      {/*  components={{*/}
      {/*    ValueContainer: ValueContainerDisplayResult*/}
      {/*  }}*/}
      {/*  style={{*/}
      {/*    searchBox: {*/}
      {/*      "border-radius": "0px"*/}
      {/*    }*/}
      {/*  }}*/}
      {/*/>*/}
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    initialValues: props.hotelGroup,
    isCompanyAdmin: isCompanyAdmin(state.auth),
    isCompanyUser: isCompanyUser(state.auth),
    company: state.auth.companyObject,
    agency: agencyObject(state.auth),
    isAgencyAdmin: isAgencyAdmin(state.auth),
    isRolePlatformAdmin: isRolePlatformAdmin(state.auth),
    agencyHasCorporatePermission: agencyHasFeature(state.auth, AGENCY_PERMISSIONS.CAN_HAVE_CORPORATE_ACCOUNTS),
    agencyCanHaveChildAgencies: agencyHasFeature(state.auth, AGENCY_PERMISSIONS.CAN_ADD_CHILD_AGENCIES),
    token: token(state),
    ...state.countries,
  };
};

HotelGroupAddGroupToProgram = reduxForm({
  form: "addToPreferredProgram",
  enableReinitialize: true,
})(HotelGroupAddGroupToProgram);

HotelGroupAddGroupToProgram = connect(mapStateToProps, {
  fetchHotelGroupsForProgrammes,
  fetchAgencies,
  fetchCompanies,
  addGroupToPreferredProgramme,
})(HotelGroupAddGroupToProgram);

export default HotelGroupAddGroupToProgram;
